import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appMatchBirthdate]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MatchBirthdateDirective, multi: true }],
  standalone: false
})
export class MatchBirthdateDirective implements Validator {
  @Input('appMatchBirthdate') birthday: string; // Expected format: 'YYYY-MM-DD'

  static validator(control: AbstractControl, birthday: string): ValidationErrors | null {
    return MatchBirthdateDirective.matches(control.value, birthday) ? null : { appMatchBirthdate: true };
  }

  static matches(controlValue: string, validationBirthday?: string): boolean {
    if (!validationBirthday || !controlValue) return true;

    let formatted: string;
    const value = controlValue.trim();
    formatted = value.includes('/')
      ? value
          .split('/')
          .reverse()
          .map(v => v.padStart(2, '0'))
          .join('-') // DD/MM/YYYY → YYYY-MM-DD
      : value;

    return formatted === validationBirthday;
  }

  validate(control: AbstractControl) {
    return MatchBirthdateDirective.validator(control, this.birthday);
  }
}
